import styled from "styled-components";
import { textTransform } from "utils";

export const TechnologyList = styled.div.attrs({
  className: "technology-list"
})`
  display: flex;
  justify-content: center;

  .technology-list__wrapper {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-column-gap: 26px;
    grid-row-gap: 31px;
  }

  @media (min-width: 1024px) {
    .technology-list__wrapper {
      margin-left: 12px;
    }
  }

  @media (max-width: 768px) {
    .technology-list__wrapper {
      grid-template-columns: repeat(2, 1fr);
      margin: 0;
    }
  }

  @media (max-width: 500px) {
    .technology-list__wrapper {
      grid-template-columns: repeat(1, 1fr);
    }
  }
  .technology-list__item {
    .technology-list__item-image {
      height: 171px;
      width: 304px;
    }
    .technology-list__item-content {
      background: #2d2d2d;
      padding: 5px 10px 10px 10px;
      max-width: 304px;
      min-width: 140px;
      height: 130px;

      h2 {
        font-weight: 450;
        font-size: 20px;
        line-height: 22px;
        letter-spacing: 1.5px;
        text-transform: ${textTransform};
      }

      h3 {
        font-weight: 390;
        font-size: 16px;
        line-height: 24px;
        color: #979797;
        margin-top: 4px;
        /* max-width: 282px; */
        overflow: hidden;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3;
        white-space: pre-wrap;
      }
    }
  }
  @media screen and (max-width: ${({ theme }) => theme.breakPoints.sm.width}) {
    grid-template-columns: repeat(1, 1fr);
    width: 100%;
    .technology-list__item {
      .technology-list__item-image {
        height: auto;
        width: auto;
      }

      .technology-list__item-content {
         {
          max-width: 627px;
          min-width: 300px;
        }
      }
    }
  }
`;

export const Title = styled.h1`
  display: inline-block;
  vertical-align: middle;
  font-size: 2.4rem;
  font-weight: 700;
  letter-spacing: 1px;
  text-transform: ${textTransform};
  color: ${({ theme }) => theme.color.textPrimary};
  margin: 24px 0 16px 0;
`;

export const BottomEvents = styled.div.attrs({
  className: "bottom-events"
})`
  margin: 50px 0 88px 0;
  display: flex;
  justify-content: center;

  .bottom-events__wrapper {
    background: #2d2d2d;
    display: flex;
    flex-direction:column;
   gap: 15px;
    padding: 22px 16px;
    width:100%;
    

      .bottom-events__item {
        display: flex;
        flex-direction: column;
    gap: 10px;
        .bottom-events__item-image {
          height: 171px;
          width: 304px;
        }
        .event_title p{
          font-size: 40px;
        }
    
        h2 {
          font-weight: 450;
          font-size: 20px;
          line-height: 22px;
          letter-spacing: 1.5px;
          text-transform: ${textTransform};
          margin-top: 22px;
        }
    
        h3 {
          font-weight: 390;
          font-size: 16px;
          line-height: 24px;
          color: #979797;
          max-width: 282px;
          margin-top: 27px;
        }
      }
      @media screen and (max-width: ${({ theme }) =>
    theme.breakPoints.sm.width}) {
        grid-template-columns: repeat(1, 1fr);
        width: 100%;

        .bottom-events__item {
          margin-top: 22px;
          :first-child {
            margin-top: 0;
          }

          .bottom-events__item-image { {
            height: auto;
            width: auto;
          }
        }
      }
  }
`;

export const TechnologyItem = styled.div`
  display: block;
`;

export const ContainerDiv = styled.div`
  display: flex;
  justify-content: center;
  font-size: 18px;
  line-height: 20px;
  padding: 0.2rem;
  margin-top: 69px;
`;

export const PageContainerDiv = styled.div.attrs({
  className: 'page-conainer-div'
})`
  padding: 15px;
  background: #222222;
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.5), 0px 4px 8px rgba(0, 0, 0, 0.5);
  border-radius: 8px;
`;

export default TechnologyList;
